import {
	GET_ALL_MISSTATEMENTS,
	GET_MISSTATEMENT_METRICS,
	LIST_MISSTATEMENTS,
	DELETE_MISSTATEMENT,
	CLEAR_MISSTATEMENTS_FOR_CATEGORY,
	ADD_MISSTATEMENT_REVIEW,
	REMOVE_MISSTATEMENT_REVIEW
} from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';
import {isApiResponseOk, isNullOrUndefined} from '../../util/utils';
import initialState from '../initialstate';
import {calculateMisstatementAmount} from '../../components/Common/CanvasForm/Bodies/BodyTypes/BodySpecial/SadSummary/sadSummaryCalculations';

export default function misstatementsReducer(state = initialState.misstatements, action) {
	switch (action.type) {
		case GET_ALL_MISSTATEMENTS:
			if (isApiResponseOk(action)) {
				let newState = null;
				if (action.response.data.length > 0) {
					newState = action.response.data.map((item) => {
						return {
							...item,
							id: item.misstatementId
						};
					});
					if (action.response.page !== 1) {
						newState = [...(state && state.data ? state.data : []), ...newState];
					}
					newState = {
						totalEntityCount: action.response?.totalEntityCount,
						pages: action.response?.pages,
						page: action.response?.page,
						data: newState
					};
				}

				return {
					...state,
					...(newState || {
						totalEntityCount: 0,
						pages: 1,
						page: 1,
						data: []
					})
				};
			}
			return state;
		case LIST_MISSTATEMENTS:
			if (isApiResponseOk(action)) {
				const rawKey = action.filterMisstatementCategory;
				const filterKey = Array.isArray(rawKey) ? rawKey[0] : rawKey;
				const mappedData = (action.response?.data ?? []).map((item) => ({
					...item,
					id: item.misstatementId,
					computedAmount: calculateMisstatementAmount(item, filterKey),
					indexedDescription: `${item.misstatementIndex} | ${item.description}`
				}));
				const updatedState = action.isManageEntities
					? {
							...state,
							data: mappedData,
							totalEntityCount: action.response?.totalEntityCount ?? 0,
							pages: action.response?.pages ?? 1,
							page: action.response?.page ?? 1
						}
					: state;

				if (isNullOrUndefined(filterKey)) {
					return updatedState;
				}

				return {
					...updatedState,
					filterMisstatementCategory: {
						...(state.filterMisstatementCategory ?? {}),
						[filterKey]: {
							totalEntityCount: action.response?.totalEntityCount ?? 0,
							pages: action.response?.pages ?? 1,
							page: action.response?.page ?? 1,
							data: mappedData
						}
					}
				};
			}
			return state;
		case GET_MISSTATEMENT_METRICS:
			if (isApiResponseOk(action)) {
				return {
					...state,
					metrics: action.response
				};
			}
			return state;
		case DELETE_MISSTATEMENT:
			if (isApiResponseOk(action) || action?.error?.response?.status === HttpStatusCodes.NotFound) {
				const deletedId = action.misstatementId;
				const existingData = state?.data ?? [];
				const filteredData = existingData.filter((item) => item.misstatementId !== deletedId && item.id !== deletedId);
				const removedFromRoot = existingData.length - filteredData.length;

				return {
					...state,
					data: filteredData,
					totalEntityCount: Math.max(0, (state?.totalEntityCount ?? existingData.length) - removedFromRoot)
				};
			}
			return state;
		case CLEAR_MISSTATEMENTS_FOR_CATEGORY: {
			const {category} = action.payload;
			return {
				...state,
				filterMisstatementCategory: {
					...(state.filterMisstatementCategory ?? {}),
					[category]: {data: [], totalEntityCount: 0}
				}
			};
		}
		case ADD_MISSTATEMENT_REVIEW:
		case REMOVE_MISSTATEMENT_REVIEW: {
			if (!isApiResponseOk(action)) {
				return state;
			}
			const reviewedMisstatementId = action.misstatementId;
			if (isNullOrUndefined(reviewedMisstatementId)) {
				return state;
			}
			const newReviewDate = action.type === ADD_MISSTATEMENT_REVIEW ? (action.response?.reviewDate ?? null) : null;
			const patchedCategories = Object.entries(state.filterMisstatementCategory ?? {}).reduce((acc, [key, bucket]) => {
				const patchedData = (bucket?.data ?? []).map((item) =>
					String(item.misstatementId) === String(reviewedMisstatementId) ? {...item, reviewDate: newReviewDate} : item
				);
				acc[key] = {...bucket, data: patchedData};
				return acc;
			}, {});
			return {
				...state,
				filterMisstatementCategory: patchedCategories
			};
		}
		default:
			return state;
	}
}
